import { Box, Container, Flex, Text } from "@chakra-ui/react";
import { useQuery } from "react-query";
import { Outlet } from "react-router-dom";

import { ErrorOutline } from "src/common/icons/ErrorOutline";
import { HTTPError, useKy } from "src/common/ky";
import { Loading } from "src/common/Loading";
import { StaffUser as StaffUserType } from "src/common/types";
import { TopBar } from "src/layout/AppLayout";

export const WrongPortalError = () => {
  return (
    <>
      <TopBar hideNavigation />
      <Container maxW="7xl" h="calc(80vh)" centerContent={true}>
        <Flex
          h="100%"
          w="50%"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
        >
          <ErrorOutline w={53} h={53} color="#FF595E" mb={30} />
          <Box>
            <Text fontSize="30px" fontWeight={600} textAlign="center">
              It seems you don&apos;t have permission to log in to this portal.
            </Text>
          </Box>
        </Flex>
      </Container>
    </>
  );
};

export const StaffUserLoader = () => {
  const ky = useKy();
  const query = useQuery<StaffUserType, HTTPError>(`STAFF_USER`, () =>
    ky.get(`staff-users/self`).json<StaffUserType>()
  );

  if (query.isLoading || !query.isSuccess) {
    return <Loading />;
  }

  if (!query.data) {
    return <WrongPortalError />;
  }

  return <Outlet />;
};
